/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Title_MainInputs */

const vi_report_title_main = /** @type {(inputs: Report_Title_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo`)
};

/**

* @param {Report_Title_MainInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_title_main = /** @type {((inputs?: Report_Title_MainInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Title_MainInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_title_main(inputs)
});